import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const statusConfig = {
  DRAFT: { label: 'Draft', variant: 'secondary', className: 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200' },
  SUBMITTED: { label: 'Submitted', variant: 'default', className: 'bg-blue-500 text-white' },
  NEED_INFO: { label: 'Need Info', variant: 'default', className: 'bg-orange-500 text-white' },
  READY_FOR_REVIEW: { label: 'Ready for Review', variant: 'default', className: 'bg-yellow-500 text-white' },
  SUBMITTED_TO_IRS: { label: 'Submitted to IRS', variant: 'default', className: 'bg-green-500 text-white' },
  IN_REVIEW: { label: 'In Review', variant: 'default', className: 'bg-yellow-500 text-white' },
  PROCESSING: { label: 'Processing', variant: 'default', className: 'bg-purple-500 text-white' },
  APPROVED: { label: 'Approved', variant: 'default', className: 'bg-green-500 text-white' },
  COMPLETED: { label: 'Completed', variant: 'default', className: 'bg-green-600 text-white' },
  REJECTED: { label: 'Rejected', variant: 'destructive', className: 'bg-red-500 text-white' },
  // Lowercase variants for backward compatibility
  draft: { label: 'Draft', variant: 'secondary', className: 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200' },
  submitted: { label: 'Submitted', variant: 'default', className: 'bg-blue-500 text-white' },
  in_review: { label: 'In Review', variant: 'default', className: 'bg-yellow-500 text-white' },
  completed: { label: 'Completed', variant: 'default', className: 'bg-green-600 text-white' },
  rejected: { label: 'Rejected', variant: 'destructive', className: 'bg-red-500 text-white' },
  active: { label: 'Active', variant: 'default', className: 'bg-green-500 text-white' },
  inactive: { label: 'Inactive', variant: 'secondary', className: '' },
  no_filing: { label: 'No Filing', variant: 'secondary', className: 'bg-gray-300 text-gray-600' },
};

export const StatusBadge = ({ status, className }) => {
  // Normalize status to uppercase for lookup, handle null/undefined
  const normalizedStatus = status ? status.toString().toUpperCase() : 'DRAFT';
  const config = statusConfig[normalizedStatus] || statusConfig[status] || { label: status || 'Unknown', variant: 'secondary', className: 'bg-gray-400 text-white' };
  
  return (
    <Badge 
      variant={config.variant}
      className={cn(config.className, className)}
    >
      {config.label}
    </Badge>
  );
};
